// Quick Add Modal Functionality
(function() {
  'use strict';

  // Function to fetch product content and display modal
  async function handleQuickAdd(productHandle, quickAddBtn) {
    try {
      // Fetch the product page
      const response = await fetch(`/products/${productHandle}`);
      if (!response.ok) {
        throw new Error('Failed to fetch product');
      }
      
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Get the variant popup div
      const variantPopup = doc.querySelector('div#variantPopup');
      if (!variantPopup) {
        console.error('Variant popup not found in product page');
        return;
      }
      
      // Get the product main script
      const productMainScript = doc.querySelector('#productmainjs');
      const productMainStyle = doc.querySelector('#mainstyle');
      
      // Check if modal container exists, if not create it
      let modalContainer = document.querySelector('#quickAddModalContainer');
      if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.classList.add('temp--product--new');
        modalContainer.id = 'quickAddModalContainer';
        document.body.appendChild(modalContainer);
      }
      
      // Clear previous content
      modalContainer.innerHTML = '';
      
      // Clone and append the variant popup
      const clonedPopup = variantPopup.cloneNode(true);
      modalContainer.appendChild(clonedPopup);
      
      // Add the showing class to make it visible
      setTimeout(() => {
        quickAddBtn.classList.remove('cloading');
        clonedPopup.classList.add('showing');
      }, 10);
      
      // If productMainScript exists, execute it
      if (productMainScript) {
        // Create a new script element and copy the content
        const newScript = document.createElement('script');
        newScript.textContent = productMainScript.textContent;
        
        modalContainer.appendChild(newScript);
      }

        // Create a new script element and copy the content
        const newStyle = document.createElement('style');
        newStyle.innerHTML = productMainStyle.innerHTML;
        modalContainer.appendChild(newStyle);
        createProductIframe(productHandle);
      
      addCloseListeners(clonedPopup);
      
    } catch (error) {
      console.error('Error loading product:', error);
      alert('Failed to load product. Please try again.');
    }
  }
  function createProductIframe(productHandle) {
  // Find the container
  const container = document.querySelector('#quickAddModalContainer .pxFormGenerator');
  
  if (!container) {
    console.error('.pxFormGenerator element not found');
    return;
  }
  
  // Create iframe
  const iframe = document.createElement('iframe');
  iframe.src = `https://formbuilder.hulkapps.com/corepage/customform?id=mp5UK5pQW09SKFcTwz1VoQ&referrer_url=https%3A%2F%2Fgeovannisuits.com%2Fproducts%2F${productHandle}`;
  iframe.id = 'frame_mp5UK5pQW09SKFcTwz1VoQ';
  iframe.frameBorder = '0';
  iframe.width = '100%';
  iframe.style.height = '588px';
  
  // Clear container and append iframe
  container.innerHTML = '';
  container.appendChild(iframe);
}
  // Function to add close listeners
  function addCloseListeners(popup) {
    // Close on clicking outside the popup content
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        closeModal(popup);
      }
    });
    
    // Close on clicking close button (common selectors)
    const closeButtons = popup.querySelectorAll('.close, .modal-close, [data-close], .popup-close');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => closeModal(popup));
    });
    
    // Close on ESC key
    const escHandler = (e) => {
      if (e.key === 'Escape') {
        closeModal(popup);
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }
  
  // Function to close modal
  function closeModal(popup) {
    popup.classList.remove('showing');
    document.body.style.overflow = '';
    
    // Remove the popup after animation
    setTimeout(() => {
      const container = document.querySelector('#quickAddModalContainer');
      if (container) {
        container.innerHTML = '';
      }
    }, 300); // Adjust timing based on your CSS transition duration
  }
  
  // Event delegation for quick-add buttons
  document.addEventListener('click', function(e) {
    const quickAddBtn = e.target.closest('.quick-add-btn');
    
    if (quickAddBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      const productHandle = quickAddBtn.getAttribute('data-product-handle');
      
      if (productHandle) {
        quickAddBtn.classList.add('cloading');
        handleQuickAdd(productHandle, quickAddBtn);
      } else {
        console.error('No product handle found on button');
      }
    }
  });
  
})();